import { getApi, postApi } from './api-utils';

const siteCurrentCache = new Map();
const siteCurrentRequests = new Map();

export const getLabCurr = async () => {
    const Lab_endpoint = 'api/v1/ma/get-lab-current';
    return getApi(Lab_endpoint);
}

export const getDlCurr = async () => {
    const DL_endpoint = 'api/v1/ma/get-dl-current';
    return getApi(DL_endpoint);
}

export const getDashboard1 = async () => {
    const Dashboard1_endpoint = 'api/v1/ma/get-dashboard-1';
    return getApi(Dashboard1_endpoint);
}


export const getDashboard2 = async () => {
    const Dashboard2_endpoint = 'api/v1/ma/get-dashboard-2';
    return getApi(Dashboard2_endpoint);
}

export const getLocations = async () => {
    const location_api = 'api/v1/ma/get-install-locations';
    return getApi(location_api);
}

export const getRawRecords = async ({ softid }) => {
    return postApi('api/v1/ma/get-raw-records', { softid });
}

export const getSiteCurr = async ({ where }) => {
    let param;
    if (where === 0) {
        param = 'lab';
    } else if (where === 1) {
        param = 'ex';
    } else {
        param = 'dl';
    }
    // console.log('where', where)
    const endpoint = `api/v1/ma/get-sites-current/${param}`;
    if (siteCurrentCache.has(endpoint)) {
        return siteCurrentCache.get(endpoint);
    }

    if (siteCurrentRequests.has(endpoint)) {
        return siteCurrentRequests.get(endpoint);
    }

    const request = getApi(endpoint)
        .then((res) => {
            siteCurrentCache.set(endpoint, res);
            return res;
        })
        .finally(() => {
            siteCurrentRequests.delete(endpoint);
        });

    siteCurrentRequests.set(endpoint, request);
    return request;
}




// export {
//     getManagement,
//     // insertMangement,
// }
